<template>
  <a-drawer
    placement="right"
    :visible="visible"
    @close="onClose"
    width="500"
    height="40vh"
    :mask="false"
    :wrap-class-name="wrapClassName"
  >
    <template slot="title">
      <slot name="title" />
    </template>
    <slot />
    <div class="answer-operation" @click="answerOperation">
      {{ foldText }}
    </div>
  </a-drawer>
</template>
<script>
// 答案折叠
const ANSWER_FOLD = 'xkh-teacher-answer-fold'
export default {
  props: {
    title: String,
    foldTitle: String,
    unfoldTitle: String
  },
  data() {
    return {
      visible: this.value,
      wrapClassName: ''
    }
  },
  computed: {
    foldText() {
      const { wrapClassName, unfoldTitle, foldTitle } = this
      if (wrapClassName) {
        return unfoldTitle
      }
      return foldTitle
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.wrapClassName = ''
      }
    }
  },
  methods: {
    answerOperation() {
      const { wrapClassName } = this
      this.wrapClassName = wrapClassName ? '' : ANSWER_FOLD
    },
    onClose() {
      this.visible = false
      this.wrapClassName = ANSWER_FOLD
    },
    show() {
      this.visible = true
      this.wrapClassName = ''
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.ant-drawer-content-wrapper) {
  // height: 48vh;
}
:deep(.ant-drawer-content) {
  overflow: initial !important;
}
:deep(.ant-drawer-wrapper-body) {
  overflow: initial !important;
}
:deep(.answer-loading) {
  height: 100%;
}
:deep(.empty-wrap) {
  position: relative;
  top: 50%;
  transform: translateY(-50%)
}
:deep(.answer-wrap) {
  height: 100%;
  position: relative;
}
.answer-operation {
  position: absolute;
  background: #FFFFFF;
  box-shadow: -12px 0px 48px 16px rgba(0, 0, 0, 0.03), -9px 0px 28px rgba(0, 0, 0, 0.05), -6px 0px 16px -8px rgba(0, 0, 0, 0.08);
  border-radius: 8px 0px 0px 8px;
  width: 29px;
  height: 96px;
  left: -29px;
  top: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 8px;
  color: #3262FD;
  cursor: pointer;
}
</style>
<style>
.xkh-teacher-answer-fold .ant-drawer-content-wrapper {
  right: -500px;
  left: auto;
}
</style>